import React, { useState, useEffect } from 'react';

import './home.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import CustomPagination from '../../components/pagination/customPagination';
import { useNavigate, useParams, useLocation } from "react-router-dom";




import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import PropertyCard from '../../components/property/propertyCard';

import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';
import * as locationActions from '../../store/location/actions';
import * as actionsPropertyType from '../../store/propertyType/actions';




const SalesProperties = ({getPropertiesForSale, salesProperties, getPropertyTypes, propertyTypeWithAttributes, fetchLocations, suggestedLocation}) => {   
    let match = useParams("/:type/properties-to-buy/:propertyType"); 
    const selectedPropertyType = match.type.charAt(0).toUpperCase() + match.type.slice(1);
    const propertyTypeID = match.propertyType;

    const [ currentPage, setCurrentPage] = useState(1);
    const [ formData, setFormData ] = useState({
        title: '',
        location: '',
        property_type: '',
        property_type_id: ''
    });
    const [propertyTypes, setPropertyTypes] = useState('');
    const [ propertyTypeSubCategory, setPropertyTypeSubCategory ] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [ resultText, setResultText ] = useState('');
    const [ activeLocationId, setActiveLocationID ] = useState();

    useEffect(() => {
		loadData();
	},[]);

    useEffect(() => {
        if(propertyTypeWithAttributes){
		    setPropertyTypes(propertyTypeWithAttributes);
            if(selectedPropertyType == 'Residential'){
                setPropertyTypeSubCategory(propertyTypeWithAttributes['residential_properties'])
            } else if(selectedPropertyType == 'Commercial'){
                setPropertyTypeSubCategory(propertyTypeWithAttributes['commercial_properties'])
            }
        }
	},[propertyTypeWithAttributes]);

    const loadData = async() => {
        await getPropertiesForSale({is_sale: 1, page: currentPage}).then(res => {
            // console.log()
        });
        await getPropertyTypes().then(res => {
            // console.log()
        })
    }

    const findValueByAttributeCode = (attribute_code, attributes) => {
        const attributeObject = attributes.find(
            (attribute) => attribute.code === attribute_code
        );
        return attributeObject && attributeObject.value ? attributeObject.value : null;
    }

    

    const handlePageChange = (page) => {
        if (page >= 1 && page <= salesProperties.pagination.total_pages) {
          setCurrentPage(page);
          let data = formData;
            data.page = page;
            data.is_sale = 1;
            getPropertiesForSale(data).then(res => {
                // console.log()
            });
        }
    };

    const updateInputValue = (value) => {
        setInputValue(value);
        setFormData({
            ...formData,
            location: value
        });
    }

    // When Click on Location and try to find out location
    const handleInputChange = (event) => {
        
        const { name, value } = event.target;
        setInputValue(value);
        setFormData({
            ...formData,
            [name]: value
        });
        
        // Fetch suggestions from the server when the input changes
        fetchLocations({searchTerm: value}).then(res => {
            if(value.length > 4 && res.payload.data && res.payload.data.length == 0){
                setResultText('No Results Found');
            } else {
                setResultText('');
            }
        });
    };


    // When Change Property type then change values of 
    const handlePropertyTypeChange = (event) => {
        const { name, value } = event.target;
        if(value == 'Residential'){
            setPropertyTypeSubCategory(propertyTypes['residential_properties'])
        } else if(value == 'Commercial'){
            setPropertyTypeSubCategory(propertyTypes['commercial_properties'])
        }
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleChange = (event) => {
        
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
        
    };

    const handleSubmit = async (event) => { 
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setCurrentPage(1);
        let data = formData;
        data.page = 1;
        data.is_sale = 1;
        getPropertiesForSale(data).then(res => {
            // console.log()
        });
    }
    
    // console.log('salesProperties', salesProperties)
    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5 bg-dark'>
                <Container>
                    <div className='card p-3 border-0'>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col>
                                    <Form.Control placeholder="Keywords" name="title" onChange={handleChange} />
                                </Col>
                                <Col>
                                    <Form.Select aria-label="Propery Status" name="property_type" onChange={handlePropertyTypeChange} defaultValue={selectedPropertyType}>
                                        <option value="">Choose Property Type</option>
                                        <option value="Commercial">Commercial Property</option>
                                        <option value="Residential">Residential Property</option>
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Form.Select aria-label="Property Type" name="property_type_id" onChange={handleChange} defaultValue={propertyTypeID}>
                                        <option value="">Property Type</option>
                                        {
                                            propertyTypeSubCategory ?
                                                propertyTypeSubCategory.map((subcategory) => (
                                                <option key={`subcategory${subcategory.property_type_id}`} value={subcategory.property_type_id}>
                                                    {subcategory.title}
                                                </option>
                                                ))
                                            : ''
                                        }
                                    </Form.Select>
                                </Col>
                                <Col>
                                    <Form.Group as={Col}  controlId="formGroupLocation">
                                        {/* <Form.Label>Location</Form.Label> */}
                                        <Form.Control type="text" placeholder="Location" name="location" 
                                            value={inputValue} 
                                            onChange={handleInputChange} 
                                            className={ "mb-3"}
                                        />
                                    </Form.Group>
                                    { 
                                        suggestedLocation && suggestedLocation.length > 0 ?
                                            <div className="autocomplete-result">
                                                <ul>
                                                {
                                                    suggestedLocation.map((location, index) => {
                                                        return <li key={`top30Trendingside${index}`} className={activeLocationId == location.location_id ? 'active' : ''} onClick={() => setActiveLocationID(location.location_id)}>
                                                                    
                                                                    <div className="content">
                                                                        <div>
                                                                            <div className="track-name">
                                                                                <div className="text-2" dangerouslySetInnerHTML={{__html: location.location_name}} onClick={() => updateInputValue(location.location_name)}></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            </li>
                                                    })
                                                    
                                                }
                                                </ul>
                                            </div>
                                        : ''
                                    }
                                </Col>
                                <Col xs={1}>
                                    <Button type="submit" variant="primary">Search</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Container>
            </section>
            { 
            salesProperties && salesProperties.properties && salesProperties.properties.length > 0 ?
            <section className='pt-5 pb-5'>
                <Container>
                    { salesProperties && salesProperties.pagination && salesProperties.pagination.totalRecords ?<h5 className="mb-4"> {salesProperties.pagination.totalRecords } Results</h5> : ''}
                    <Row>
                    { 
                        salesProperties.properties.map((property, propertyIndex) => {
                            return <Col xs={4} key={`property${propertyIndex}${property.entity_id}`}>
                                        <PropertyCard item={property} />
                                    </Col>
                        })
                    }                        
                    </Row>
                    <div className="justify-content-center d-flex">
                    {
                        salesProperties.pagination
                            ? 
                            <CustomPagination 
                                totalPages={salesProperties.pagination.total_pages} 
                                currentPage={salesProperties.pagination.page} 
                                onPageChange={handlePageChange} 
                            />
                        : ''
                    }
                    </div>
                </Container>
            </section>
            : ''
            }
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        salesProperties: state.property.salesProperties,
        suggestedLocation: state.location.suggestedLocation,
        propertyTypeWithAttributes: state.propertyType.propertyTypeWithAttributes,
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getPropertyTypes: () => dispatch(actionsPropertyType.getPropertyTypes()),
        fetchLocations: (post) => dispatch(locationActions.getAutocompleteLocation(post)),
        getPropertiesForSale: (post) => dispatch(actions.getPropertiesForSale(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(SalesProperties);